import Vue from 'vue'
import {
  Button,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  NoticeBar,
  Radio,
  RadioGroup,
  Stepper,
  Swipe,
  SwipeItem,
} from 'vant'

Vue.component('CSwipe', Swipe)
Vue.component('CSwipeItem', SwipeItem)
Vue.component('CNoticeBar', NoticeBar)
Vue.component('CCheckbox', Checkbox)
Vue.component('CButton', Button)
Vue.component('CCheckboxGroup', CheckboxGroup)
Vue.component('CRadioGroup', RadioGroup)
Vue.component('VRadio', Radio)
Vue.component('CCellGroup', CellGroup)
Vue.component('CStepper', Stepper)
const context = require.context('.', true, /^\.\/C.*\/index.js$/)
window.context = context
const componentList = context.keys()

componentList.forEach((key) => {
  if (key?.split('/')?.length === 3) {
    Vue.component(`C${key.slice(3, -9)}`, context(key).default || context(key))
  }
})
